<template>
  <h3>
    <slot name="headline">{{ headline }}</slot>
  </h3>
  <div class="share-input">
    <input :value="props.url" readonly class="share-url" ref="shareInput" />
    <button @click="copyShareLink" class="copy-btn">
      {{ copied ? 'Copied!' : 'Copy' }}
    </button>
  </div>
  <p class="share-note">
    <slot>Anyone with this link can view this.</slot>
  </p>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = withDefaults(
  defineProps<{
    url: string
    headline?: string
  }>(),
  {
    url: '',
    headline: 'Share Link',
  },
)

const copied = ref(false)
const shareInput = ref<HTMLInputElement>()

async function copyShareLink() {
  if (!shareInput.value) {
    return
  }

  try {
    await navigator.clipboard.writeText(props.url)
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000)
  } catch {
    // Fallback for older browsers
    shareInput.value.select()
    document.execCommand('copy')
    copied.value = true
    setTimeout(() => {
      copied.value = false
    }, 2000)
  }
}
</script>

<style scoped lang="scss">
.share-input {
  display: flex;
  gap: 8px;
  margin-bottom: 8px;

  .share-url {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid var(--border-color);
    border-radius: 4px;
    background: var(--input-bg);
    color: var(--text-primary);
    font-family: monospace;
    font-size: 14px;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .copy-btn {
    padding: 8px 16px;
    border: 1px solid var(--primary-color);
    border-radius: 4px;
    background: var(--primary-color);
    color: white;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: var(--primary-color-dark);
    }
  }

  .share-note {
    font-size: 12px;
    color: var(--text-secondary);
    margin: 0;
  }
}
</style>
